import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Suspense, lazy } from 'react';
import { Header } from './components/header/header';
import { Footer } from './components/footer/footer';
import { PageClub } from './components/page-club';
import { PageMentor } from './components/page-mentor';
import { Page404 } from './components/page-404/Page404';
import styles from './App.module.css';

const PageBooks = lazy(() => import('./components/page-books').then(m => ({ default: m.PageBooks })));
const PageOtzyvy = lazy(() => import('./components/page-otzyvy').then(m => ({ default: m.PageOtzyvy })));
const PageAbout = lazy(() => import('./components/page-about').then(m => ({ default: m.PageAbout })));
const PageWhyMe = lazy(() => import('./components/page-whyme').then(m => ({ default: m.PageWhyMe })));
const PageContacts = lazy(() => import('./components/page-contacts').then(m => ({ default: m.PageContacts })));
const PageClubOnly = lazy(() => import('./components/page-club-only').then(m => ({ default: m.PageClubOnly })));
const PageBlog = lazy(() => import('./components/page-blog').then(m => ({ default: m.PageBlog })));
const PageArticle = lazy(() => import('./components/page-article').then(m => ({ default: m.PageArticle })));

function LoadingFallback() {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '300px', color: '#9ca3af' }}>
      Загрузка…
    </div>
  );
}

function App() {
  return (
    <Router>
      <div className={styles.appContainer}>
        <Header />
        <Suspense fallback={<LoadingFallback />}>
          <Routes>
            <Route path="/" element={<PageClub />} />
            <Route path="/club" element={<PageClubOnly />} />
            <Route path="/blog" element={<PageBlog />} />
            <Route path="/blog/:slug" element={<PageArticle />} />
            <Route path="/about" element={<PageAbout />} />
            <Route path="/stack" element={<Navigate to="/books" replace />} />
            <Route path="/portfolio" element={<Navigate to="/books" replace />} />
            <Route path="/whyme" element={<PageWhyMe />} />
            <Route path="/contacts" element={<PageContacts />} />
            <Route path="/mentor" element={<PageMentor />} />
            <Route path="/books" element={<PageBooks />} />
            <Route path="/otzyvy" element={<PageOtzyvy />} />
            <Route path="*" element={<Page404 />} />
          </Routes>
        </Suspense>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
